import Header from "@/components/shared/Header";
import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormikProvider, useFormik } from "formik";
import { toast } from "react-toastify";
import Input from "@/components/forms/Input";
import { Checkbox } from "primereact/checkbox";

export default function EditRole() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const isUpdate = state?.id ? true : false;

  const [saveLoading, setSaveLoading] = React.useState<boolean>(false);
  const listwrapper =
    "border-1 border-gray-400 p-4 flex flex-row align-items-center border-round";

  const formik = useFormik({
    initialValues: {
      name: state?.name ?? "",
      active: state?.active ?? false,
      priviledges: state?.priviledges ?? {
        MANAGE_USER: false,
        MANAGE_ROLE: false,
        MANAGE_CTE: false,
        DASHBOARD: false,
        DATA_ENTRY: false,
        HISTORY: false,
      },
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: any = {};

      if (!values.name) {
        errors.name = "Name of the role is required";
      }

      return errors;
    },
    onSubmit: (values) => {
      if (isUpdate) {
        setSaveLoading(true);
        setTimeout(() => {
          setSaveLoading(false);
          toast.success("Role updated successfully");
        }, 1000);
      } else {
        setSaveLoading(true);
        setTimeout(() => {
          setSaveLoading(false);
          toast.success("Role created successfully");
        }, 1000);
      }
    },
  });

  const { values, handleSubmit, setFieldValue } = formik;

  // convert a string of the form MANAGE_USER to Manage User for display purposes
  const formatPriviledge = (priviledge: string) => {
    const words = priviledge.split("_");
    const capitalizedWords = words.map((word) => {
      return word.charAt(0) + word.slice(1).toLowerCase();
    });

    return capitalizedWords.join(" ");
  };

  return (
    <div>
      <Header
        onBack={() => navigate(-1)}
        title={isUpdate ? "Edit Role" : "Create Role"}
        extraAction="Save"
        extraActionIcon="pi pi-save"
        onExtraAction={() => handleSubmit()}
        extraActionLoading={saveLoading}
      />

      <FormikProvider value={formik}>
        <div className="flex flex-column gap-4 p-3 md:p-5">
          <section className={`${listwrapper} gap-5 flex-wrap`}>
            <div className="col-12 md:col-6">
              <Input id="name" label="Role Name" placeholder="eg. Admin" />
            </div>

            <div
              className="flex flex-row align-items-center gap-2 pl-3 md:pl-0 md:mt-4"
             
            >
              <span>Mark as active</span>
              <InputSwitch
                checked={values.active}
                onChange={(e) => {
                  setFieldValue("active", e.value);
                }}
              />
            </div>
          </section>

          <section className={`${listwrapper} gap-6 flex-wrap`}>
            {Object.keys(values.priviledges).map((priviledge) => (
              <div className="flex flex-row align-items-center gap-3">
                <label htmlFor={priviledge} className="text-lg">
                  {formatPriviledge(priviledge)}
                </label>

                <Checkbox
                  checked={values.priviledges[priviledge]}
                  icon="pi pi-check text-white"
                  aria-label={priviledge}
                  onChange={(e) => {
                    setFieldValue(
                      "priviledges",
                      Object.assign({}, values.priviledges, {
                        [priviledge]: e.checked,
                      })
                    );
                  }}
                />
              </div>
            ))}
          </section>
        </div>
      </FormikProvider>
    </div>
  );
}
